module.exports = __webpack_public_path__ + "static/media/emoji-strongly-agree.20128627.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/emoji-strongly-agree.svg
// module id = 456
// module chunks = 0